import * as React from 'react';
import './button.less';

// [COMPONENT USAGE]
/* <Button
	primary
	text="Test"
	onClick={() => {
		console.log('test');
	}}
></Button>; */

/* <Button
	primary
	disabled
	text="Test"
></Button>; */

export interface ButtonProps {
	/** Text to be shown inside the button */
	text?: string;
	/** Sets the button to it's primary colors */
	primary?: boolean;
	/** Sets the button to it's secondary colors */
	secondary?: boolean;
	/**Sets the button to to it's secondary colors(black) */
	tertiary?: boolean;
	/** Sets the type of the button */
	type?: 'button' | 'reset' | 'submit';
	/** Show the button in it's disabled state */
	disabled?: boolean;
	/** Sets if button should not submit in form */
	noSubmit?: boolean;
	/**Sets an alternative color to the button , the background will be white*/
	alternativeFontColor?: string;
	/**Sets the event of the onClick*/
	onClick?(event?: any): void;
}

export const Button = (props: ButtonProps): JSX.Element => {
	const { text, onClick, type, disabled, primary, alternativeFontColor, tertiary, secondary, noSubmit } = props;
	return (
		<>
			<button
				type={type}
				onClick={e => {
					onClick && onClick(e);
					noSubmit && e.preventDefault();
				}}
				className={`ds-button ds-button-${(primary && 'primary') ||
					(secondary && 'secondary') ||
					(tertiary && 'tertiary')}  ${alternativeFontColor}`}
				disabled={disabled}
			>
				{text}
			</button>
		</>
	);
};
